import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Business } from './../../accesslog/models/accesslog';
import { BusinessSignedService } from './businessSigned.service';


@Injectable()
export class BusinessSignedUsersListResolver {
    constructor(private backend: BusinessSignedService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<Business[]> {
        return this.backend.getAllUsers(+route.parent?.params['bid']);
    }
}

